import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      if (err.message) {
        setError(err.message);
      } else {
        setError('Unable to connect. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#05070d] flex flex-col relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        />
      </div>

      {/* Decorative glow */}
      <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-blue-400/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-blue-300/10 rounded-full blur-3xl pointer-events-none"></div>

      {/* Navigation */}
      <nav className="relative z-10 py-6 px-6 lg:px-12 border-b border-white/10 bg-[#05070d]/95 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <Link to="/" className="flex items-center gap-3">
            <img
              src={logo}
              alt="RAL Real Advisor"
              className="w-10 h-10 object-contain"
            />
            <div className="flex items-center">
              <span className="text-2xl font-serif font-bold text-white">RAL</span>
              <span className="text-2xl font-serif font-light text-[#9fc6ff] ml-1">
                Real Advisor
              </span>
            </div>
          </Link>

  
        </div>
      </nav>

      {/* Main Content */}
      <div className="relative z-10 flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          {/* Header */}
          <div className="text-center mb-10">
            <span className="text-[#9fc6ff] text-sm font-medium tracking-[0.3em] uppercase mb-4 block">
              Welcome Back
            </span>
            <h1 className="text-4xl font-serif font-bold text-white mb-3">
              Sign In
            </h1>
            <p className="text-neutral-400">
              Access your account and continue your work
            </p>
          </div>

          {/* Form Card */}
          <div className="bg-neutral-800/50 backdrop-blur border border-neutral-700/50 p-8">
            {/* Error Message */}
            {error && (
              <div className="mb-6 p-4 bg-red-900/20 border border-red-700/40">
                <p className="text-red-300 text-sm">{error}</p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Email */}
              <div>
                <label className="block text-sm font-medium text-neutral-300 mb-2 tracking-wide uppercase">
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 bg-neutral-900 border border-neutral-700 text-white placeholder-neutral-500 focus:outline-none focus:border-[#9fc6ff] transition-colors"
                  placeholder="your@email.com"
                  required
                />
              </div>

              {/* Password */}
              <div>
                <label className="block text-sm font-medium text-neutral-300 mb-2 tracking-wide uppercase">
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-3 bg-neutral-900 border border-neutral-700 text-white placeholder-neutral-500 focus:outline-none focus:border-[#9fc6ff] transition-colors"
                  placeholder="Enter your password"
                  required
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={loading}
                className="w-full py-4 bg-[#9fc6ff] text-[#05070d] font-medium tracking-wide uppercase hover:opacity-90 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
            </form>

            {/* Register Link */}
            {/* <p className="mt-8 text-center text-neutral-400">
              Don&apos;t have an account?{' '}
              <Link
                to="/register"
                className="text-[#9fc6ff] hover:text-[#cfe2ff] font-medium transition-colors"
              >
                Create one
              </Link>
            </p> */}
          </div>

          {/* Footer */}
          <div className="mt-8 text-center">
            <p className="text-neutral-600 text-sm">
              © {new Date().getFullYear()} RAL Real Advisor Ltd
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;